var BoardState;
(function (BoardState) {
    BoardState["INITIAL"] = "INITIAL";
    BoardState["PLAYING"] = "PLAYING";
    BoardState["WON"] = "WON";
    BoardState["LOST"] = "LOST";
})(BoardState || (BoardState = {}));
export default BoardState;
